import { useState } from 'react';
import { FamilyMemberType, InsurancePolywizzStatuses, Polywizz, SubmitPolywizzParams } from '../../../interfaces/Insurance';
import { resubmitPolywizzPolicies, submitPolywizz } from '../../../utils/api/insurance';
import globalErrorHandler from '../../../utils/globalErrorHandler';
import { formatDate } from '../../../utils/formatDate';
import { Tooltip } from '@mui/material';
import Spinner from 'react-bootstrap/Spinner';
import { Client } from '../../../interfaces/Client';

const ResubmitInsurnace = ({
    familyMemberType,
    isMountainDate,
    insuranceId,
    polywizz,
    client,
}: {
    familyMemberType: FamilyMemberType;
    isMountainDate: boolean;
    insuranceId?: string;
    polywizz: Polywizz | null;
    client: Client;
}) => {
    const [isPolywizzResubmitLoading, setIsPolywizzResubmitLoading] = useState<boolean>(false);
    const [isPolywizzResubmitSuccess, setIsPolywizzResubmitSuccess] = useState<boolean>(false);

    const handleResubmitPolywizz = async (isMountainData: boolean, familyMemberType?: FamilyMemberType) => {
        try {
            setIsPolywizzResubmitLoading(true);
            if (!isMountainData && polywizz) {
                await resubmitPolywizzPolicies({ polywizzId: polywizz._id });
            } else {
                const data: SubmitPolywizzParams = polywizz
                    ? { polywizzId: polywizz._id }
                    : { insuranceId, signee: familyMemberType as 'client' | 'spouse' };
                await submitPolywizz(data);
            }
            setIsPolywizzResubmitSuccess(true);
        } catch (err) {
            globalErrorHandler(err);
        } finally {
            setIsPolywizzResubmitLoading(false);
        }
    };

    if (client && ['spouse', 'client'].includes(familyMemberType)) {
        const date = isMountainDate ? polywizz?.submissionTime : polywizz?.policiesSubmissionTime;
        const resubmitMountainAllowed = true;
        const resubmitPoliciesAllowed =
            polywizz &&
            [
                InsurancePolywizzStatuses.completedPoliciesNotRequired,
                InsurancePolywizzStatuses.timeout,
                InsurancePolywizzStatuses.mountainDataReceived,
                InsurancePolywizzStatuses.policiesError,
                InsurancePolywizzStatuses.almostCompleted,
                InsurancePolywizzStatuses.completed,
            ].includes(polywizz.status);

        const resubmitAllowed = isMountainDate ? resubmitMountainAllowed : resubmitPoliciesAllowed;

        return (
            <span className="d-inline-flex align-items-center gap-1">
                {date ? formatDate(date) : 'Not submitted'}{' '}
                {resubmitAllowed && (
                    <Tooltip arrow placement="top" title={!isMountainDate ? 'Resubmit/fetch policies' : 'Resubmit/fetch mountain data'}>
                        {isPolywizzResubmitLoading ? (
                            <Spinner animation="border" variant="secondary" size="sm" />
                        ) : isPolywizzResubmitSuccess ? (
                            <i className="fas fa-check-circle text-success"></i>
                        ) : (
                            <i
                                className="mdi mdi-reload text-secondary cursor-pointer"
                                onClick={() => handleResubmitPolywizz(isMountainDate, familyMemberType)}
                            ></i>
                        )}
                    </Tooltip>
                )}
            </span>
        );
    } else {
        return <></>;
    }
};

export default ResubmitInsurnace;
